import styled from 'styled-components';

export const ContainerConfirmation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const ContentButtons = styled.div`
  display: flex;
  gap: 8px;
`;
